export type DatabaseRangePreset = 'lastMonth' | 'lastQuarter' | 'lastYear';

export interface DatabaseRangePresetRange {
	start: Date;
	end: Date;
}

export const DATABASE_RANGE_PRESETS: readonly DatabaseRangePreset[] = ['lastMonth', 'lastQuarter', 'lastYear'];

export function isDatabaseRangePreset(value: unknown): value is DatabaseRangePreset {
	return typeof value === 'string' && (DATABASE_RANGE_PRESETS as readonly string[]).includes(value);
}

/** Month arithmetic relies on Date normalizing out-of-range months (e.g. month -1 becomes December of the previous year). */
export function resolveDatabaseRangePreset(preset: DatabaseRangePreset, referenceDate: Date): DatabaseRangePresetRange {
	const year = referenceDate.getFullYear();
	const month = referenceDate.getMonth();

	switch (preset) {
		case 'lastMonth':
			return { start: new Date(year, month - 1, 1), end: new Date(year, month, 0) };
		case 'lastQuarter': {
			const previousQuarterStartMonth = (Math.floor(month / 3) - 1) * 3;
			return {
				start: new Date(year, previousQuarterStartMonth, 1),
				end: new Date(year, previousQuarterStartMonth + 3, 0),
			};
		}
		case 'lastYear':
			return { start: new Date(year - 1, 0, 1), end: new Date(year - 1, 11, 31) };
	}
}
